module.exports = "label {\r\n    color: blue;\r\n}\r\n\r\n.in-box {\r\n    border: 1px solid gray;\r\n    width: 100%;\r\n    height: 315px;\r\n}\r\n\r\n.in-box .row {\r\n    margin: 10px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/voucher-report/voucher-report.component.css
// module id = ./src/app/reports/voucher-report/voucher-report.component.css
// module chunks = main